import { render } from "./GmailTagIndicator.vue?vue&type=template&id=580eb2e6"
import script from "./GmailTagIndicator.vue?vue&type=script&lang=js"
export * from "./GmailTagIndicator.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__